exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".explore{display:flex;height:100%;overflow:hidden;flex-grow:1;flex-direction:column}.explore h1{padding-top:64px}.explore .content{display:flex;overflow:hidden;flex-grow:1;flex-direction:row}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/routes/account/style.scss
// module id = 281
// module chunks = 0